import { render, staticRenderFns } from "./LoginMain.vue?vue&type=template&id=77d77a49"
import script from "./LoginMain.vue?vue&type=script&lang=js"
export * from "./LoginMain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports